import { createContext } from "react"

export type LocalStorageContextValue = {
  clearedAt: string | undefined;
}

type ContextType = LocalStorageContextValue | null

export const LocalStorageContext = createContext<ContextType>(null)
